module.exports = __webpack_public_path__ + "static/media/IconTemplates_-30.089b69eb.svg";